import React 		from 'react';
import ReactDOM from 'react-dom';

import BLComponent from '../core/_BLComponent.jsx';

import InputLabelSet 	from '../common/_InputLabelSet.jsx';
import {ClickShowTooltip, CustomConfirm, CustomAlert} from '../common/_Utilities.jsx';

export default class ForgotPassword extends BLComponent {

	constructor(props, context) {
		super(props, context);

		this.state = {
			emailAddress: blapp.util.getUrlVar( "email" ) || '',
			noAccount: false,
			emailError: false,
			validResetLink: blapp.util.getUrlVar( "email" ) != null ? false : true,
			emailValid: true,

			showRecovery: false
		}
	}

	render() {
		return (
			<div className="main l-margin-y--xxl main--x-thin">
				{this.state.showRecovery ? this.recoveryModal() : null}
				<div className="main__content">
					{!this.state.validResetLink && 
						<div className="notification notification--error notification--tight l-flex l-center l-margin-bottom">
							<i className="fas fa-exclamation-triangle text-color--primaryRed l-margin-right--sm"/>
							<p>Your password reset link has expired.</p>
						</div>
					}
					<h1 className="l-margin-bottom--sm page-title l-block text--center">Reset password</h1>
					<p className="text--center l-margin-bottom--xl">Enter the email address associated with your BrickLink account. We will send a verification email with instructions on updating your password.</p>
					<InputLabelSet data={{label: "Email address", inputValue: this.state.emailAddress, onChangeFunc: (newVal) => this.updateEmailAddress(newVal), validation: this.state.noAccount ? "error" : (this.state.emailValid ? "" : "error")}}/>
					{this.state.noAccount && <p className="text--small text-color--primaryRed l-margin-top--sm l-margin-bottom--xl">We could not find an account for the email address you entered. Please check for errors or try a different address.</p>}
					{this.state.emailError && <p className="text--small text-color--primaryRed l-margin-top--sm l-margin-bottom--xl">There was an error sending the reset email. Please try again later.</p>}
					<button className="btn btn--cta text--bold l-margin-top l-margin-bottom l-block l-full-width" disabled={!this.state.emailValid} onClick={() => this.triggerSend()}>Send verification email</button>
					<button className="btn btn--link text--small" onClick={() => this.back()}><i className="fas fa-long-arrow-left l-margin-right--sm"/>Back to log in</button>
				</div>
			</div>
		);
	}

	recoveryModal() {
		const urlParams = `email=${this.state.emailAddress}`;

		return (
			<article className="modal">
				<div className="modal__overlay" onClick={() => this.setState({showRecovery: false})}></div>
				<div className="modal__content modal__content--login-register">
					<div className="modal__body text--center">
						<div className="text--right">
							<i className="far fa-times modal__close text--small-title" onClick={() => this.setState({showRecovery: false})}></i>
						</div>
						<h2 className="text--small-title text--bold l-margin-bottom">Extra verification needed</h2>
						<p className="l-margin-bottom--xl">We're asking you to verify your identity to make sure only authorized users are accessing your account.</p>
						<a href={blapp.url2.getAccountRecoveryUrl(urlParams)} className="btn btn--cta text--bold l-block">Verify my identity</a>
					</div>
				</div>
			</article>
		);
	}

	triggerSend() {
		this.setState({noAccount: false, emailError: false});
		blapp.models.fetch(
			"forgotPassword"
		,	{
				controller:	"user.BLCUserPassword"
			,	method:		"forgotPassword"
			,	params:		[this.state.emailAddress]
			,	refresh:	true
			}
		).then(
			( data ) =>
			{
				if(data == "EC_LOGIN_ACC_RECOVERY_REQUIRED") {
					this.setState({showRecovery: true});
				}else if(data == "EC_OK"){
					this.resendModal();
				}
				else if(data == "EC_INVALID_PARAM"){
					this.setState({noAccount: true});
				}
				else if(data == "EC_UNREGISTERED_ERROR"){
					this.setState({emailError: true});
				}
			}
		).catch ( 
			( error ) =>
			{
				console.log("Error");
				this.setState({emailError: true});
			}
		);
		
	}

	back() {
		window.location.href = blapp.util.constructFullUrl(blapp.url2.getUrlInfoBase('/login.page'));
	}

	resend() {
		blapp.models.fetch(
			"forgotPassword"
		,	{
				controller:	"user.BLCUserPassword"
			,	method:		"forgotPassword"
			,	params:		[this.state.emailAddress]
			,	refresh:	true
			}
		).then(
			( data ) =>
			{
				if(data == "EC_UNREGISTERED_ERROR"){
					this.triggerAlert('There was an error sending the reset email. Please try again later.');
				}
			}
		).catch ( 
			( error ) =>
			{
				console.log("Error");
				this.triggerAlert('There was an error sending the reset email. Please try again later.');
			}
		);
	}

	updateEmailAddress(newVal) {
		this.setState({emailAddress: newVal});
	}

	resendModal() {
		const confirmContent = `<h2 class="page-title l-margin-bottom--sm">Reset password</h2>
			<p class="l-margin-bottom text--center">We sent an email to <strong>${this.state.emailAddress}</strong>. Please follow the instructions in the email to reset your password. It may take some time for the email to arrive depending on your email service provider.</p>
			<p class="l-margin-bottom text--center">If you still haven’t received an email from us, click the button below to resend the verification email.</p>
			<p class="l-margin-bottom text--center">If you no longer have access to your email account, please contact support at <a href="mailto:bricklink@support.lego.com">bricklink@support.lego.com</a>.</p>`;

		CustomConfirm(confirmContent, {false: 'Close', true: 'Resend email'}, 'custom-confirm--inline-buttons').then(value => {
			if(value == true) {
				this.resend();
			}
			else{
				window.history.back();
			}
		});
	}

	triggerAlert(message) {
		const confirmContent = `<i class="text-color--primaryRed fas fa-exclamation-triangle l-margin-bottom"></i>
		<p class="text-color--primaryRed">${message}</p>`;

		CustomAlert(confirmContent);
	}


};

document.addEventListener( "DOMContentLoaded", 
	function() {
		var	elem	=	ReactDOM.render(
							<ForgotPassword blctx={{parent: null, idx:0}} />
						,	document.getElementById( 'bl-main' )
						);
		blapp.refs.register( "main", elem );
	}
);